import { vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-22px <lg:text-14px relative" }
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.type === 'textarea')
      ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
          key: 0,
          placeholder: _ctx.placeholder,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
          class: _normalizeClass(["resize-none border-2px px-20px rounded-5px py-15px h-full appearance-none outline-none w-full border-e1e1e1 text-7e7e7e focus:border-hex-6664D6", {
        '!border-hex-E18989': _ctx.error,
        '!text-hex-D23636': _ctx.error,
        'placeholder-hex-D23636': _ctx.error,
      }])
        }, null, 10, _hoisted_2)), [
          [_vModelText, _ctx.value]
        ])
      : (_ctx.type !== 'tel')
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value) = $event)),
            ref: "input",
            class: _normalizeClass(["border-2px px-20px rounded-5px py-12px h-full appearance-none outline-none w-full border-hex-e1e1e1 text-hex-7e7e7e focus:border-hex-6664D6", {
        '!border-hex-E18989': _ctx.error,
        '!text-hex-D23636': _ctx.error,
        'placeholder-hex-D23636': _ctx.error,
      }]),
            type: "text",
            placeholder: _ctx.placeholder
          }, null, 10, _hoisted_3)), [
            [_vModelText, _ctx.value]
          ])
        : (_openBlock(), _createElementBlock("input", {
            key: 2,
            ref: "input",
            class: _normalizeClass(["border-2px px-20px rounded-5px py-12px h-full appearance-none outline-none w-full border-hex-e1e1e1 text-hex-7e7e7e focus:border-hex-6664D6", {
        '!border-hex-E18989': _ctx.error,
        '!text-hex-D23636': _ctx.error,
        'placeholder-hex-D23636': _ctx.error,
      }]),
            type: "text",
            placeholder: _ctx.placeholder
          }, null, 10, _hoisted_4))
  ]))
}